export const ACTION_TYPES = {
	SET_CART_DATA: 'SET_CART_DATA',
	SET_FULL_SHIPPING_ADDRESS_PUSHED: 'SET_FULL_SHIPPING_ADDRESS_PUSHED',
	SET_ERROR_DATA: 'SET_ERROR_DATA',
	APPLYING_COUPON: 'APPLYING_COUPON',
	REMOVING_COUPON: 'REMOVING_COUPON',
	RECEIVE_CART_ITEM: 'RECEIVE_CART_ITEM',
	ITEM_PENDING_QUANTITY: 'ITEM_PENDING_QUANTITY',
	SET_IS_CART_DATA_STALE: 'SET_IS_CART_DATA_STALE',
	RECEIVE_REMOVED_ITEM: 'RECEIVE_REMOVED_ITEM',
	UPDATING_CUSTOMER_DATA: 'UPDATING_CUSTOMER_DATA',
	SET_BILLING_ADDRESS: 'SET_BILLING_ADDRESS',
	SET_SHIPPING_ADDRESS: 'SET_SHIPPING_ADDRESS',
	UPDATING_SELECTED_SHIPPING_RATE: 'UPDATING_SELECTED_SHIPPING_RATE',
	TRIGGER_ADDING_TO_CART_EVENT: 'TRIGGER_ADDING_TO_CART_EVENT',
	TRIGGER_ADDED_TO_CART_EVENT: 'TRIGGER_ADDED_TO_CART_EVENT',
} as const;
